module.exports = __webpack_public_path__ + "static/corezoid-3f37648389841bbebec5c5cd7a028744.png";